import React from "react";
import { Link } from "react-router-dom"; // If using React Router

const TermsAndConditions = () => {
  return (
    <section className="px-[10px] md:px-[20px] lg:px-[10%]">
      <div className="">
        <h1 className="text-2xl font-semibold mb-4">Terms and Conditions</h1>

        <p className="mb-4">
          Welcome to [Your Ecommerce Website]! These terms and conditions
          outline the rules and regulations for the use of our website.
        </p>

        <h2 className="text-xl font-semibold mb-2">Intellectual Property</h2>
        <p className="mb-4">
          All content on this website, including text, images, graphics, and
          logos, is the property of ISTORE and is protected by applicable
          intellectual property laws.
        </p>

        <h2 className="text-xl font-semibold mb-2">Privacy</h2>
        <p className="mb-4">
          Your privacy is important to us. Please refer to our{" "}
          <Link to="/privacy-policy" className="text-blue-500 hover:underline">
            Privacy Policy
          </Link>{" "}
          for detailed information on how we collect, use, and protect your
          personal information.
        </p>

        <h2 className="text-xl font-semibold mb-2">Shipping and Returns</h2>
        <p className="mb-4">
          For information about shipping and returns, please visit our{" "}
          <Link
            to="/shipping-returns"
            className="text-blue-500 hover:underline"
          >
            Shipping and Returns
          </Link>{" "}
          page.
        </p>

        {/* Add more sections as needed */}

        <h2 className="text-xl font-semibold mb-2">Changes to Terms</h2>
        <p className="mb-4">
          We reserve the right to modify these terms and conditions at any time.
          You should check this page regularly for updates.
        </p>

        <h2 className="text-xl font-semibold mb-2">Contact Us</h2>
        <p className="mb-4">
          If you have any questions or concerns about these terms and
          conditions, please{" "}
          <Link to="/contact" className="text-blue-500 hover:underline">
            contact us
          </Link>
          .
        </p>

        <p className="text-sm text-gray-500">Last updated: [Date]</p>
      </div>
    </section>
  );
};

export default TermsAndConditions;
